import { EncodingValidationResponse } from 'stylewhere/api'
import { AppStore } from 'stylewhere/shared'
import { EncodingOperationConfig } from 'stylewhere/shared/RemoteOperation'
import { isPreEncodingWorkOrder } from 'core/shared/utils'

export * from 'core/shared/utils'

export const isEncodingAuditLogEnabled = () => true

export const GUCCI_MISSING_PREENCODING_ERROR = 'GUCCI_MISSING_PREENCODING'
export const GUCCI_MISSING_START_ENTITY_ERROR = 'GUCCI_MISSING_START_ENTITY'

const MISSING_TAG_ERRORS = ['MISSING_OPTIONAL_TAG', 'MISSING_MANDATORY_TAG']

// validazione dei tag prima della scelta della taglia (pre-encoding by work order con griglia taglie)
export const isTagValidationBeforeSizeSelection = (operation: EncodingOperationConfig) =>
  isPreEncodingWorkOrder(operation) &&
  operation.options?.workOrderRowSelectionMode === 'sizeGrid' &&
  // eslint-disable-next-line @typescript-eslint/dot-notation
  operation.attributes?.['enableTagValidationBeforeSizeSelection'] === 'true'

// tag ammissibili per il preencoding: la validate senza taglia fallisce solo per GUCCI_MISSING_START_ENTITY
export const isReadyForSizeSelection = (response?: EncodingValidationResponse) => {
  const errors = response?.errors?.filter((error) => error.errorCode !== 'MISSING_OPTIONAL_TAG') ?? []
  return (
    response?.operationToPerform === 'FAIL' &&
    errors.length === 1 &&
    errors[0].errorCode === GUCCI_MISSING_START_ENTITY_ERROR
  )
}

// errore atteso nella validate senza taglia: non deve produrre il suono KO se non ci sono altri errori
export const hasOnlyMissingStartEntityError = (errors?: EncodingValidationResponse['errors']) =>
  !!errors?.some((error) => error.errorCode === GUCCI_MISSING_START_ENTITY_ERROR) &&
  errors.every(
    (error) => error.errorCode === GUCCI_MISSING_START_ENTITY_ERROR || MISSING_TAG_ERRORS.includes(error.errorCode)
  )

export type MissingPreEncodingBehaviour = 'ignore' | 'warnWithAutoconfirm' | 'warnWithUserConfirmation'

export const getMissingPreEncodingBehaviour = (): MissingPreEncodingBehaviour | undefined => {
  const value = AppStore.defaultWorkstation?.attributes?.missingPreEncodingBehaviour
  if (value === 'ignore' || value === 'warnWithAutoconfirm' || value === 'warnWithUserConfirmation') {
    return value
  }
  return undefined
}

export const hasGucciMissingPreEncodingError = (errors?: EncodingValidationResponse['errors']) =>
  !!errors?.some((error) => error.errorCode === GUCCI_MISSING_PREENCODING_ERROR)

export const shouldSuppressMissingPreEncodingKoSound = (errors?: EncodingValidationResponse['errors']) => {
  if (getMissingPreEncodingBehaviour() !== 'ignore' || !errors?.length) return false

  const relevantErrors = errors.filter(
    (error) => !['MISSING_OPTIONAL_TAG', 'MISSING_MANDATORY_TAG'].includes(error.errorCode)
  )
  return (
    relevantErrors.length > 0 &&
    relevantErrors.every((error) => error.errorCode === GUCCI_MISSING_PREENCODING_ERROR)
  )
}

export function getCustomErrorCodes(status: number | undefined): { [key: string]: string } {
  switch (status) {
    default:
      return {}
  }
}

export const getEncodingBlockingErrors = (enableUhfWrite = 'no') => {
  const blockedErrors = [
    'WRONG_PRODUCTION_ORDER',
    'WRONG_PLACE',
    'PRODUCTION_ORDER_ROW_CREATION_ERROR',
    'GUCCI_ERROR_PRODUCT_VARIANT',
    'GUCCI_ERROR_PRODUCT_NOT_VARIANT',
    'GUCCI_ERROR_PRODUCT_MISSING_EAN'
  ]
  if (enableUhfWrite === 'gs1') {
    blockedErrors.push('MISSING_EAN_ATTRIBUTE')
  }
  return blockedErrors
}
